import * as React from 'react';
import { SearchForm } from '../core/SearchForm';
import { HotelBedData } from '../shared/HotelBedData';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { newI18n } from 'src/core';
export interface HotelsSearchProps extends BaseComponentProps {
    lang: string;
    currency: string;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    count: number;
    externalFilter: HotelBedData.ExternalFilter;
    hotelCodes?: number[];
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter;
    specialPage?: boolean;
}
export interface HotelsSearchState extends BaseComponentState {
    searchColapse: boolean;
    copalseIcon: any;
    searchClassname: string;
}

export class HotelsSearch extends BaseComponent<HotelsSearchProps, HotelsSearchState> {

    translation = { 
        SearchHotels: newI18n("SEARCHFORM.SearchHotels", "Search Hotels")
    };
    
    constructor(props: HotelsSearchProps) {
        super(props);
        let searchClassname = 'hide';
        let copalseIcon = <i className="ti-plus" />;
        if (props.specialPage) {
            this.translation["SearchHotels"] =  newI18n("SEARCHFORM.SearchHotels.special", "Find Bali's Best Hotel Deals");
            searchClassname = "";
            copalseIcon = <i className="ti-minus" />;
        }
        this.state = {
            searchColapse: false,
            copalseIcon: copalseIcon,
            searchClassname: searchClassname
        };
    }

    colapse: () => any = () => {
        this.setStateHelper(
            st => {
                let vsearchColapse = true;
                let vcopalseIcon = <i className="ti-minus" />;
                let vsearchClassname = ' ';
                if (this.state.searchColapse) {
                    vsearchColapse = false;
                    vcopalseIcon = <i className="ti-plus" />;
                    vsearchClassname = 'hide';
                }
                st.searchColapse = vsearchColapse;
                st.copalseIcon = vcopalseIcon;
                st.searchClassname = vsearchClassname;
            });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        return (
            <div>
                <div className="search-form-horisontal-action">
                    <div className="panel panel-white" id="panel1">
                        <div className="panel-heading">
                            <h4 className="panel-title text-primary">Search Hotels</h4>
                            <div className="panel-tools" >
                                <a
                                    data-original-title="Collapse"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    className="btn btn-transparent btn-sm"
                                    onClick={(event) => {
                                        this.colapse();
                                    }}
                                >{this.state.copalseIcon}
                                </a>
                            </div>
                        </div>
                        <div className={this.state.searchClassname}>
                            <SearchForm
                                /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                                lang={this.props.lang}
                                showtitle={false}
                                style='horisontal'
                                count={this.props.count}
                                getHotels={this.props.getHotels}
                                externalFilter={this.props.externalFilter}
                                hotelCodes={this.props.hotelCodes}
                                filter={this.props.initialFilter}
                                specialPage={this.props.specialPage}
                            />
                        </div>
                    </div>
                </div>
                <div className='search-form-horisontal'>
                    <SearchForm
                        
                        lang={this.props.lang}
                        showtitle={false}
                        style='horisontal'
                        count={this.props.count}
                        getHotels={this.props.getHotels}
                        externalFilter={this.props.externalFilter}
                        hotelCodes={this.props.hotelCodes}
                        filter={this.props.initialFilter}
                        /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/HotelsSearch.tsx